import Action from '../base/action';

class LoadViewpoint extends Action {
    position;
    quaternion;
    viewpointId;
    viewpointApplyMode;
    travelDuration;

    constructor(props) {
        super(props);
        this.position = props.position;
        this.quaternion = props.quaternion;
        this.viewpointId = props.viewpointId;
        this.viewpointApplyMode = props.viewpointApplyMode || '2D';

        let travelDuration = parseFloat(isNullOrUndefined(props.travelDuration) ? '2' : props.travelDuration);
        if (isNaN(travelDuration) || travelDuration < 0) {
            travelDuration = 2;
        }
        this.travelDuration = travelDuration;
        this.positionOnlyInXR = props.positionOnlyInXR || false;
    }

    async execute({training}) {
        if ((isVRModeEnabled() || isMobileARModeEnabled()) && this.viewpointApplyMode === '2D') {
            return;
        }

        const viewpoint = training.resources[this.viewpointId];
        let calculatedViewpointValues;
        if (viewpoint && viewpoint.viewpointObj) {
            calculatedViewpointValues = ViewPointManager.getCameraConfiguration(parseData(viewpoint.viewpointObj));
        }

        let resourceLocalCameraConfiguration;
        if (viewpoint && viewpoint.position && viewpoint.quaternion) {
            resourceLocalCameraConfiguration = ViewPointManager.getCameraConfiguration({
                position: new THREE.Vector3(...viewpoint.position),
                orientation: new THREE.Quaternion(...viewpoint.quaternion),
                model: viewpoint.model,
                attachedBranchId: viewpoint.attachedBranchId,
            });
        }

        const positionValue = this.position
            ? this.position
            : (resourceLocalCameraConfiguration?.position
                ? getArrayFromObj(resourceLocalCameraConfiguration.position)
                : getArrayFromObj(calculatedViewpointValues.position));
        let quaternionValue = this.quaternion
            ? this.quaternion
            : (resourceLocalCameraConfiguration?.orientation
                ? getArrayFromObj(resourceLocalCameraConfiguration.orientation)
                : getArrayFromObj(calculatedViewpointValues.orientation));

        if (this.positionOnlyInXR && this.viewpointApplyMode === '2D and XR' && (isVRModeEnabled() || isMobileARModeEnabled())) {
            let cameraQuaternion = iq3Camera.getConfigurationWorld().orientation;
            quaternionValue = [cameraQuaternion.x, cameraQuaternion.y, cameraQuaternion.z, cameraQuaternion.w];
        }

        iq3Camera.zoomCamera(1);
        ViewPointManager.setViewpoint(wv.registeredID, new THREE.Vector3(...positionValue), new THREE.Quaternion(...quaternionValue), true, this.travelDuration);

        function getArrayFromObj(obj) {
            return Object.values(obj).filter(val => {
                return typeof val !== 'boolean';
            });
        }

        function parseData(viewpointData) {
            return {
                position: new THREE.Vector3(
                    parseFloat(viewpointData.cameraPosition.x),
                    parseFloat(viewpointData.cameraPosition.y),
                    parseFloat(viewpointData.cameraPosition.z)
                ),
                orientation: new THREE.Quaternion(
                    parseFloat(viewpointData.cameraOrientation.x),
                    parseFloat(viewpointData.cameraOrientation.y),
                    parseFloat(viewpointData.cameraOrientation.z),
                    parseFloat(viewpointData.cameraOrientation.w)
                ),
                attachedVolumeName: viewpointData.attachedVolumeName
            };
        }
    }
}

export default LoadViewpoint;
